import { CheckCircleIcon, BanknotesIcon } from '@heroicons/react/24/outline';
import Routes from '@/router/Routes.ts';

export const navData = [
  {
    title: 'navbar.settings__consents',
    path: Routes.SETTINGS__CONSENTS,
    icon: <CheckCircleIcon />,
  },
  {
    title: 'navbar.settings__billing',
    path: Routes.SETTINGS__SUBSCRIPTION,
    icon: <BanknotesIcon />,
  },
  // {
  //   title: 'navbar.settings__projects',
  //   path: Routes.SETTINGS__PROJECTS,
  //   icon: <ClipboardDocumentIcon />,
  // },
];
